// extracted by mini-css-extract-plugin
export default {"cls1":"kjYlQNvjUcP0gq1fQyrq","cls2":"M3UCsoR3BBgv5uUgwvTY kjYlQNvjUcP0gq1fQyrq"};